var _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgProfilePicPlaceholder = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 133,
    viewBox: "0 0 133 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 66.5,
    cy: 66.5,
    r: 66.5,
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 105.113,
    y1: 12.871,
    x2: 16.625,
    y2: 122.274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.458333,
    stopColor: "#E6005F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458433,
    stopColor: "#3C82DA"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgProfilePicPlaceholder);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/profile_pic_placeholder.8da480b593b45f319d9ca1c0400645e6.svg";